// Copyright (c) Ensho Health, 2021 to present

import actions from '../action';
import { combineReducers } from 'redux';
import app from './app.reducer.js';
import auth from './auth.reducer.js';
import user from './user.reducer.js';
import heartbeat from './heartbeat.reducer.js';
import encryption from './encryption.reducer.js';
import labResult from './lab-result.reducer.js';
import pii from './pii.reducer.js';
import patient from './patient.reducer.js';
import cdlServices from './cdl-services.reducer.js';
import notification from './notification.reducer.js';

const appReducer = combineReducers({
  auth,
  user,
  app,
  heartbeat,
  encryption,
  labResult,
  pii,
  patient,
  cdlServices,
  notification
});

const reducer = (state, action) => {
  // when the user signs out, the current state should be wiped out.
  // this will force all the stored data to be reset to their initial state
  if (action.type === actions.auth.ACTION_TYPES.LOGOUT) {
    localStorage.clear();
    state = undefined;
  }

  return appReducer(state, action);
};

export default reducer;
